import { jsx as _jsx } from "react/jsx-runtime";
import { create } from 'zustand';
export const useToast = create((set) => ({
    message: null, tone: 'default',
    show: (message, tone = 'default') => { set({ message, tone }); setTimeout(() => set((s) => (s.message === message ? { message: null } : s)), 2400); },
    clear: () => set({ message: null }),
}));
export function ToastHost() {
    const { message, tone } = useToast();
    if (!message)
        return null;
    return _jsx("div", { role: "status", className: "tl-in", style: { position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)', background: tone === 'danger' ? 'var(--danger)' : 'var(--primary)', color: '#fff', padding: '9px 14px', borderRadius: 4, fontSize: 12.5, fontWeight: 500, zIndex: 100, boxShadow: 'var(--shadow-drawer)' }, children: message });
}
//# sourceMappingURL=Toast.js.map